import { render, staticRenderFns } from "./PurchaseResult.vue?vue&type=template&id=a434a534&scoped=true"
import script from "./PurchaseResult.vue?vue&type=script&lang=js"
export * from "./PurchaseResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a434a534",
  null
  
)

export default component.exports